import React, { FunctionComponent } from 'react';
import { Column, Row } from '@/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { PackI } from '@/containers/ActionServiceV2/utils';

type ListPacksProps = {
  packs?: PackI[];
  deletePack: (id: number) => void;
  isStripeConnected: boolean;
};

export const ListPacks: FunctionComponent<ListPacksProps> = ({ packs, deletePack, isStripeConnected }) => {
  if (!packs) return null;

  return (
    <Column gap={16}>
      {packs?.map(({ limit, price, price_usd }, index) => (
        <Row align="center" gap={8} key={index} className="w-full">
          <Row
            align="center"
            justify="space-between"
            className="w-4/5 md:w-1/2 rounded-lg border border-[#DADCE0] bg-[#FFF] shadow-[0px_4px_20px_0px_#0000001C] p-4"
          >
            <p>{limit} Reservas</p>
            <p>$ {price}</p>
            {isStripeConnected && <p>US$ {price_usd}</p>}
          </Row>
          <Row
            justify="center"
            align="center"
            className="cursor-pointer w-9 h-9 shadow-[0px_3px_4px_0px_rgba(0,0,0,0.3)] rounded-full bg-[#868686] hover:bg-[#FF4658] transition-colors duration-300"
          >
            <FontAwesomeIcon
              icon={faTrashCan}
              color="#FFF"
              size="1x"
              onClick={() => deletePack(index)}
              fixedWidth
            />
          </Row>
        </Row>
      ))}
    </Column>
  );
};
